// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_LCvJC","startPage":"style_startPage_BF60Z","cube":"style_cube_2qOlB"};